// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2AVys","disabled":"FileBtn_disabled__3snEw","warn":"FileBtn_warn__3Qvvb","fade":"FileBtn_fade__3udEr"};